import React, {useState, useRef} from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { Menu, Avatar, Drawer, Divider, Button, Modal } from 'antd';
import throttle from 'lodash.throttle';
// import PropTypes from 'prop-types';
import HeaderProfileContainer from '../containers/HeaderProfileContainer';
import SVG from 'react-inlinesvg';
import {
  MenuOutlined,
  ArrowUpOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';


const Dashboard = ({
  location,
  children,
}) => {

  const [scrollTop, setScrollTop] = useState(0);
  const [narrowDrawer, setNarrowDrawer] = useState(false);
  const [feedbackDrawerVisible, setFeedbackDrawerVisible] = useState(false);

  const navMenu = [
    { label: "Pages", link: "/pages", iconActive: <SVG src={require('assets/media/tab/tab-pages-active.svg')} />, icon: <SVG src={require('assets/media/tab/tab-pages.svg')} />},
    { label: "Leads", link: "/leads", iconActive: <SVG src={require('assets/media/tab/tab-leads-active.svg')} />, icon: <SVG src={require('assets/media/tab/tab-leads.svg')} />},
    { label: "Domains", link: "/domains", iconActive: <SVG src={require('assets/media/tab/tab-domains-active.svg')} />, icon: <SVG src={require('assets/media/tab/tab-domains.svg')} />},
    { label: "Gallery", link: "/gallery", iconActive: <SVG src={require('assets/media/tab/tab-gallery-active.svg')} />, icon: <SVG src={require('assets/media/tab/tab-gallery.svg')} />},
  ].map((item, index) => (
    <div
      key={`menu-item-${index}`}
      className={cx("navSideMenu py-2", {
        active: (location.pathname).startsWith(item.link),
      })}
    >
      <Link to={item.link} onClick={()=>setNarrowDrawer(false)}>
        <div className="d-flex align-items-center">
          <div className="tab-icon-holder mr-2">
            { (location.pathname).startsWith(item.link) ? item.iconActive : item.icon }
          </div>
          <div>{item.label}</div>
        </div>
      </Link>
    </div>
  ));

  const productSupport = () => {
    Modal.info({
      title: 'Product support',
      content: (
        <div>
          Drop us a mail at support@pagehits.io and someone will get back to you within 24 business hours.
        </div>
      ),
      onOk() {},
    });
  };

  const shareFeedback = () => {
    setFeedbackDrawerVisible(true);
  };

  // useEffect(()=>{
  //
  // },);

  const actionMenu = [
    { label: 'Help articles', ext: true, fn: ()=>window.open("https://www.pagehits.io/how-to/introduction", "_blank") },
    { label: 'Feedback', fn: shareFeedback },
    { label: 'Product support', fn: productSupport },
  ].map((item, index)=>(
    <div className="actionSideMenu" key={`action-item-${index}`}>
      <Button
        type="link" className="px-0 py-2"
        onClick={item.fn}
      >
        {item.label}
        {item.ext ? <ArrowUpOutlined className="tiltedExt ml-2" /> : null}
      </Button>
    </div>
  ));


  // Listen to the scroll event and add a shadow under the header bar
  // if content scrolls vertically past a threshold
  const scrollingDiv = useRef(null);
  const SCROLL_HANDLER_DELAY_MILISECONDS = 180;
  const Y_OFFSET_THRESHOLD = 18;
  const onContentScroll = throttle(() => {
    const { scrollTop: newScrollTop } = scrollingDiv.current;
    if ( (newScrollTop > Y_OFFSET_THRESHOLD && scrollTop > Y_OFFSET_THRESHOLD) || (newScrollTop === scrollTop)) {
      return;
    }
    setScrollTop(newScrollTop);
  }, SCROLL_HANDLER_DELAY_MILISECONDS);

  let headerShadowStyle = { boxShadow: "0 0.3rem 0.9rem rgba(0, 0, 0, 0.1)"};
  if (scrollTop < Y_OFFSET_THRESHOLD) {
    const fraction = scrollTop / Y_OFFSET_THRESHOLD;
    headerShadowStyle = { boxShadow: `0 ${0.3*fraction}rem ${0.9*fraction}rem rgba(0, 0, 0, 0.1)`}
  }

  return (
    <div className="dashboard__layout bg-light">

      <div className="dashboard__layout__header bg-light position-fixed w-100 d-flex" style={headerShadowStyle}>
        <div className="container-xl d-flex align-items-center flex-row justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <Avatar
              shape="circle" icon={<MenuOutlined />}
              className="nav-hamburger mr-2 d-inline-block d-md-none"
              onClick={()=>setNarrowDrawer(true)}
            />
            <SVG className="dashboard-logo" src={require('assets/media/brand/logo-app-navbar.svg')} />
          </div>
          <div>
            <HeaderProfileContainer />
          </div>
        </div>
      </div>

      <div className="dashboard__layout__content" onScroll={onContentScroll} >
        <div className="dashboard__content__scroll_inner pt-3 pb-5" ref={scrollingDiv}>
          <div className="container-xl ">
            <div className="row">
              <div className="col-md-9 col-lg-10 offset-md-3 offset-lg-2">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard__layout__sidemenu position-fixed d-none d-md-block">
        <div className="container-xl">
          <div className="row">
            <div className="col-md-3 col-lg-2">
              <div className="sidemenu_viewport">
                <div className="sidemenu_scroll py-3">
                  { navMenu }
                  <Divider className="mt-5 mb-4" />
                  { actionMenu }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Drawer
        title={
          <Avatar
            shape="circle"
            className="nav-hamburger"
            onClick={()=>setNarrowDrawer(false)}
            icon={<ArrowLeftOutlined />}
          />
        }
        className="narrowDrawer d-block d-md-none"
        placement="left"
        closable={false}
        onClose={()=>setNarrowDrawer(false)}
        visible={narrowDrawer}
      >
        { navMenu }
        <Divider />
        { actionMenu }
      </Drawer>

      <Drawer
        width={480}
        placement="right"
        closable={true}
        onClose={()=>setFeedbackDrawerVisible(false)}
        visible={feedbackDrawerVisible}
        title="Feedback / Bug report"
      >

        <iframe className="airtable-embed w-100 h-100 border" src="https://airtable.com/embed/shrqIOAAYVq8ZLnMZ?prefill_Email=saptarshi.17@gmail.com" frameBorder="0"></iframe>
      </Drawer>

    </div>
  );
};

export default Dashboard;



// WEBPACK FOOTER //
// ./scripts/layouts/Dashboard.jsx